export const convertBoolToNumber = (bool) => +bool;